//skip
import {
  Box,
  Divider,
  Grid,
  InputAdornment,
  LinearProgress,
  TextField,
  Typography,
} from "@material-ui/core";
import CardTable from "components/CardTable/CardTable";
import React, { useEffect, useState } from "react";
import { columnsAccountCreate } from "./columns_f";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "hooks/useForm";
import { createSelector } from "reselect";
import RegularButton from "components/CustomButtons/Button";
import SearchIcon from "@material-ui/icons/Search";
import { blue, orange } from "@material-ui/core/colors";
import { Article } from "@mui/icons-material";
import { useSearch } from "hooks/useSearch";
import { Autocomplete } from "@material-ui/lab";
import { createSettlementNewNote } from "redux/actions/routesStatus/routesStatusAction";
import moment from "moment";
import { useFetchLocal } from "hooks/fetch-hooks/useFetchLocal";
import { resetCustomersOptions } from "redux/actions/liquidations/liquidationsAction";
import { getDecimalFormat, formatNumber } from "helpers/getNumberFormats";
import { idGenerator } from "helpers/createId";
import {
  handleFetchPublicCustomers,
  handleFetchSalesAccountDetails,
  handleUltimateFetchLessData,
} from "./actions/fetchData";
import { resetOnClick } from "helpers/resetOnClick";
import CloseIcon from "@material-ui/icons/Close";
import { cleanNumber } from "helpers/cleanNumbers";
import { epoch10 } from "helpers/epoch";
import { newDate } from "helpers/dateTools";
import { useRuleValidator } from "hooks/useRuleValidator";
import { PERMISSIONS } from "router/permissions";

const productsSelector = createSelector(
  (state) => {
    return state.routesStatus.settlement.unit.priceType
      ? state.routesStatus.products.filter(
        (product) =>
          product?.type === state.routesStatus.settlement.unit.priceType
      )
      : [];
  },
  (products) => products
);

export const FormEndownmentsAccount = ({
  editNote = false,
  isNewNote = false,
  close,
  note = {},
}) => {
  const style = {
    backgroundColor: blue[100],
  };

  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { rules } = useSelector(({ login }) => login);
  const { payments, station, settlement } = useSelector(
    ({ routesStatus }) => routesStatus
  );
  const { units } = useSelector(({ unitsReducer }) => unitsReducer);
  const { station: stationLiquidation } = useSelector(
    ({ liquidations }) => liquidations
  );
  const { stations } = useSelector(({ companies }) => companies);
  const searchType = JSON.parse(localStorage.getItem("isLiquidation"));
  const isManual = settlement?.routes?.end?.isManual === 1;
  const isPortable = settlement.unit.type?.toLowerCase().includes("portatil");
  const products = useSelector((state) => productsSelector(state));
  const [blockBtn, setBlockBtn] = useState(false);
  const canChangeDate = useRuleValidator(PERMISSIONS.ENDOWMENTS_CHANGE_DATE);
  const [customDate, setCustomDate] = useState(newDate());

  const routePayments = settlement?.routes?.start?.payments || "MIXED";

  const CREDIT_TYPES = ["credito", "condonacion", "nota nacional"];

  const filterByRoutePayments = (paymentsList) => {
    if (routePayments === "MIXED") return paymentsList;
    if (routePayments === "CREDIT") {
      return paymentsList.filter((py) =>
        CREDIT_TYPES.includes(py.label?.toLowerCase())
      );
    }
    if (routePayments === "CASH") {
      return paymentsList.filter(
        (py) => !CREDIT_TYPES.includes(py.label?.toLowerCase())
      );
    }
    return paymentsList;
  };

  const {
    inputValues,
    handleNewValues,
    handleInputOnChange,
    fieldErrors,
    runValidates,
  } = useForm(
    {
      unitType: settlement?.unit?.priceType || null,
      searchCustomer: "",
      customersOpt: [],
      idAccount: null,
      folio: "",
      idPayment: null,
      paymentsOpt: filterByRoutePayments(payments.filter(
        (py) =>
          !py.method?.toLowerCase() === "credito" &&
          py.label?.toLowerCase() !== "nota nacional"
      )),
      blockPaymentMethod: payments.find((py) => py.id === note.idPayment),
      hour: moment(settlement?.routes?.start?.time).format("HH:mm"),
      date: settlement?.routes?.start?.time.split(" ")[0],
      product: null,
      amountDetail: 0,
      amount: 0,
      quantity: 0,
      price: 0,
      discount: 0,
      tax: 0,
      measureUnit: "",
      customerAccountsFilter: "",
      noteDetails: [],
      noteDetailID: "",

      unitPriceKg: 0,
      unitPriceLt: 0,
      isEdit: false,
    },
    {
      idAccount: { required: true },
      date: { required: true },
      folio: { required: true },
      idPayment: { required: true },
    }
  );
  const cols = columnsAccountCreate(
    { ...inputValues, editNote, products: products },
    handleNewValues
  );
  const {
    unitType,
    searchCustomer,
    customersOpt,
    idAccount,
    folio,
    idPayment,
    paymentsOpt,
    date,
    product,
    amountDetail,
    amount,
    quantity,
    discount,
    tax,
    noteDetails,
    noteDetailID,
    unitPriceKg,
    unitPriceLt,
    isEdit,
  } = inputValues;

  const effectiveDate = canChangeDate ? customDate : date;

  // eslint-disable-next-line
  const [[_, loadingCustomers, success], fetchCustomers] = useFetchLocal(
    handleUltimateFetchLessData
  );

  const [
    [publicData, loadingPublic, successPublic],
    fetchPublicCustomers,
  ] = useFetchLocal(handleFetchPublicCustomers);

  const [
    [detailsResponse, loadingDetails, successDetails, errorDetails],
    fetchCustomerDetails,
  ] = useFetchLocal(handleFetchSalesAccountDetails);

  const handleSearchCustomers = (e) => {
    e.preventDefault();
    dispatch(resetCustomersOptions());
    const stationsSelected = searchType ? [stationLiquidation] : [station];
    fetchCustomers(stationsSelected, searchCustomer, stations, handleNewValues);
  };

  const handleSearchPublic = (e) => {
    e.preventDefault();
    const idStation = units[settlement.unit.id].idStation;
    const priceType = settlement.unit.priceType;
    handleNewValues({ idPayment: null });
    fetchPublicCustomers(idStation, priceType, setSnackbar);
  };
  const handleAccount = (value) => {
    if (value) {
      if (!value.idMunicipality) return setSnackbar("No tiene Municipio");
      if (!value.customerCode) return setSnackbar("No tiene Codigo");
      handleNewValues({
        idAccount: value,
        searchCustomer: value.label,
        blockPaymentMethod: null,
      });
      fetchCustomerDetails(effectiveDate, value.value);
    } else {
      handleNewValues({
        idAccount: null,
        searchCustomer: "",
        idPayment: null,
        paymentsOpt: filterByRoutePayments(payments.filter(
          (py) =>
            !py.method?.toLowerCase() === "credito" &&
            py.label?.toLowerCase() !== "nota nacional"
        )),
        blockPaymentMethod: null,
      });
    }
  };

  const handlePayment = (v) => {
    handleNewValues({ idPayment: v });
  };

  const handleProduct = (v) => {
    handleNewValues({ product: v, quantity: v ? 1 : 0 });
  };

  const handleAddNoteDetail = () => {
    if(quantity <= 0) return setSnackbar("Cantidad no puede ir en 0", "warning")
    let newValues = {};
    let notesUpdated = [];
    const isCreditNote = detailsResponse.isCreditNote === 1;
    const isDiscount = isCreditNote ? 0 : detailsResponse?.discount;
    const isUnitType = "PORTATIL";
    const detailDiscount =
      unitType !== isUnitType
        ? quantity * product?.capacity * isDiscount
        : (isDiscount / 0.54) * product?.capacity * quantity;

    if (!isEdit) {
      const nPrice = unitPriceKg * product?.capacity;

      newValues = {
        id: idGenerator(),
        idProduct: product?.id,
        name: product?.name,
        quantity,
        capacity: product?.capacity,
        price:
          unitType === isUnitType
            ? formatNumber({ input: nPrice })
            : formatNumber({ input: unitPriceLt }),
        amount: parseFloat((amountDetail - detailDiscount).toFixed(2)),
        product: product,
        discount: parseFloat(detailDiscount.toFixed(2)),
      };
      notesUpdated = [...noteDetails, newValues];
      handleNewValues({
        noteDetails: notesUpdated,
        isEdit: false,
        discount:
          notesUpdated.reduce((acc, curr) => acc + curr?.discount, 0) || 0,
      });
    } else {
      const nPrice =
        unitType === "PORTATIL" ? unitPriceKg * product?.capacity : unitPriceLt;

      const nAmount =
        unitType === isUnitType
          ? unitPriceKg * product?.capacity * quantity - isDiscount
          : unitPriceLt * product.capacity * quantity - isDiscount;

      newValues = {
        id: noteDetailID,
        idProduct: product?.id,
        product: product,
        name: product?.name,
        quantity,
        capacity: product?.capacity,
        price: formatNumber({ input: nPrice }),
        amount: parseFloat(nAmount.toFixed(2)),
        discount: parseFloat(detailDiscount.toFixed(2)),
      };

      notesUpdated = noteDetails.map((note) =>
        note.id === noteDetailID ? newValues : note
      );
      handleNewValues({
        noteDetails: notesUpdated,
        isEdit: false,
        discount:
          notesUpdated.reduce((acc, curr) => acc + curr?.discount, 0) || 0,
      });
    }
    handleNewValues({
      quantity: 0,
      amountDetail: unitType === "PORTATIL" ? unitPriceKg : unitPriceLt,
    });
    return;
  };

  const handleNote = () => {
    if (runValidates()) return;
    if (canChangeDate) {
      const minDate = newDate({ diffDays: -31 });
      const maxDate = newDate();
      if (customDate < minDate || customDate > maxDate) {
        return setSnackbar(
          "La fecha de precio debe estar dentro de los últimos 31 días",
          "warning"
        );
      }
    }
    if (noteDetails.length === 0)
      return setSnackbar("No se encuentran detalles registrados", "warning");

    if (discount > 0 && idPayment?.name?.toLowerCase() === "condonacion")
      return setSnackbar(
        "No se pueden guardar notas con descuento y condonación",
        "warning"
      );

    const nDetails = noteDetails.map((note) => ({
      id: note.id,
      idProduct: note.idProduct,
      quantity: cleanNumber(note.quantity),
      price: cleanNumber(note.price),
      discount: note?.discount || 0,
      amount: parseFloat(note.amount.toFixed(2)),
      name: note.name,
      capacity: note.capacity,
      idMunicipality: idAccount?.idMunicipality || note.idMunicipality,
      idAccount: idAccount?.idAccount || note.idAccount,
      idPayment: idPayment?.id,
    }));

    const totalDiscount = nDetails.reduce(
      (acc, curr) => acc + curr?.discount,
      0
    );
    const nFolio = folio
      .toString()
      .replace(/[^0-9]/g, "")
      .trim();

    let form = {
      ...note,
      id: editNote ? note.id : idGenerator(),
      date: effectiveDate,
      folio: nFolio,
      idPayment: idPayment?.id,
      type: idPayment?.method,
      methodPayment: idPayment?.name,
      idAccount: idAccount?.idAccount || note.idAccount,
      account: idAccount?.alias || note.account,
      accountName: idAccount.alias || note.accountName,
      accountCode: idAccount?.accountCode || note.accountCode,
      customer: {
        ...note?.customer,
        account: idAccount,
        isCredit: detailsResponse?.isCredit,
        credit: detailsResponse?.credit,
      },
      idMunicipality: idAccount?.idMunicipality || note.idMunicipality,
      amount: parseFloat(amount.toFixed(2)),
      tax,
      flowMeter: 0,
      discount: parseFloat(totalDiscount.toFixed(2)),
      total: amount,
      quantity: noteDetails.reduce(
        (acc, curr) => acc + cleanNumber(curr.quantity),
        0
      ),
      details: nDetails,
      editNote: editNote,
      deleted: false,
      deletedCauseId: null,
    };
    dispatch(createSettlementNewNote(form, close));
  };

  const handleQuantity = ({ target }) => {
    const { value } = target;
    if (value < 0 || String(value).includes("-")) {
      handleNewValues({ quantity: 0 });
      return;
    }
    if (unitType === "PORTATIL") {
      const regex = /^\d*$/;
      if (regex.test(value) || value === "") {
        handleNewValues({ quantity: value });
      }
    } else {
      const regex = /^\d*(\.\d{0,2})?$/;
      if (regex.test(value) || value === "") {
        handleNewValues({ quantity: value });
      }
    }
  };
  useEffect(() => {
    if (editNote) {
      let paymentsF = [];

      if (note?.gasBonus !== null && note?.gasBonus !== 0) {
        paymentsF = payments.filter(
          (py) => py.label?.toLowerCase() === "condonacion"
        );
      } else {
        const isCredit =
          note.customer.isCredit > 0
            ? payments.find((py) => py.method?.toLowerCase() === "credito")
            : payments.find((py) => py.id === note.idPayment);

        const isNationalClient =
          payments
            .find((py) => py.id === note.idPayment)
            ?.label?.toLowerCase() === "nota nacional";

        if (isNationalClient) {
          paymentsF = payments.filter(
            (py) => py.label?.toLowerCase() === "nota nacional"
          );
        } else {
          paymentsF =
            isCredit?.label?.toLowerCase() === "credito"
              ? payments.filter(
                (py) => py.label?.toLowerCase() !== "nota nacional"
              )
              : payments.filter(
                (py) =>
                  py.label?.toLowerCase() !== "credito" &&
                  py.label?.toLowerCase() !== "nota nacional"
              );
        }
      }

      handleNewValues({
        searchCustomer: note?.customer?.account?.alias || note.accountName,
        idAccount: note.customer.account,
        folio: note.folio,
        paymentsOpt: filterByRoutePayments(paymentsF),
        date: note.date,
        amount: note.amount || 0,
        discount:
          note?.details.reduce((acc, curr) => acc + curr?.discount, 0) || 0,
        tax: note.tax,
        noteDetails: note.details,
        idPayment: payments.find((py) => py.id === note.idPayment),
        methodPayment: payments.find((py) => py.id === note.idPayment)?.name,
      });
    } else {
      handleNewValues({
        folio: epoch10(),
      });
    }
    // eslint-disable-next-line
  }, [editNote]);

  useEffect(() => {
    if (successPublic && publicData.length > 0) {
      handleNewValues({
        customersOpt: [...publicData],
        idAccount: publicData?.length === 1 ? publicData[0] : null,
        searchCustomer: publicData[0]?.label || searchCustomer,
      });
      fetchCustomerDetails(effectiveDate, publicData[0].value);
    }
    // eslint-disable-next-line
  }, [successPublic, publicData]);

  useEffect(() => {
    if (idAccount?.value) {
      let updatingDiscount = [];
      if (successDetails && !editNote) {
        const isCreditNote = detailsResponse.isCreditNote === 1;
        const isDiscount = isCreditNote ? 0 : detailsResponse?.discount;
        const isNationalClient = detailsResponse?.isNationalClient === 1;

        updatingDiscount =
          noteDetails.map((detail) => {
            const product = products.find((pr) => pr.id === detail.idProduct);
            const disc = !isPortable
              ? detail.quantity * product?.capacity * isDiscount
              : (isDiscount / 0.54) * detail.quantity * product?.capacity;
            let newAmount = isPortable
              ? detail.price * detail.quantity - disc
              : detail.price * detail.quantity * product?.capacity - disc;
            return {
              ...detail,
              discount: disc,
              amount: newAmount,
              capacity: product?.capacity,
            };
          }) || [];

        let paymentsF = [];

        const isAccount999 = idAccount.accountCode === "999";
        const hasDiscount = (isDiscount ?? 0) > 0;
        const isCredit = detailsResponse?.isCredit === 1;
        const condonationPermit = rules.includes("ENDOWMENTS-CONDONATION");

        const allowCondonation =
          (!isAccount999 && !hasDiscount) ||
          (isAccount999 && !hasDiscount && condonationPermit);

        if (isNationalClient) {
          paymentsF = payments.filter(
            (py) => py.label?.toLowerCase() === "nota nacional"
          );
        } else {
          paymentsF = payments.filter((py) => {
            const label = py.label?.toLowerCase();
            return !(
              (label === "condonacion" && !allowCondonation) ||
              (label === "credito" && !isCredit) ||
              label === "nota nacional"
            );
          });
        }
        const filteredPayments = filterByRoutePayments(paymentsF);
        handleNewValues({
          unitPriceKg: detailsResponse.unitPriceKg,
          unitPriceLt: detailsResponse.unitPriceLt,
          tax: detailsResponse.tax || 0,
          noteDetails: updatingDiscount,
          discount: isCredit
            ? 0
            : updatingDiscount.reduce((acc, curr) => acc + curr?.discount, 0),
          paymentsOpt: filteredPayments,
          idPayment: isNationalClient
            ? filteredPayments.find((py) =>
              py.label?.toLowerCase().includes("nota nacional")
            ) || filteredPayments[0] || null
            : routePayments === "CREDIT"
              ? filteredPayments.find((py) =>
                py.label?.toLowerCase().includes("credito")
              ) || filteredPayments.find((py) =>
                py.label?.toLowerCase().includes("efectivo")
              ) || filteredPayments[0] || null
              : filteredPayments.find((py) =>
                py.label?.toLowerCase().includes("efectivo")
              ) || filteredPayments[0] || null,
        });
      } else if (successDetails && editNote) {
        const isCreditNote = detailsResponse.isCreditNote === 1;
        const isDiscount = isCreditNote ? 0 : detailsResponse?.discount;
        const isNationalClient = detailsResponse?.isNationalClient === 1;

        updatingDiscount =
          noteDetails.map((detail) => {
            const product = products.find((pr) => pr.id === detail.idProduct);
            const disc = !isPortable
              ? detail.quantity * product?.capacity * isDiscount
              : (isDiscount / 0.54) * detail.quantity * product?.capacity;
            let newAmount = isPortable
              ? detail.price * detail.quantity - disc
              : detail.price * detail.quantity * product?.capacity - disc;
            return {
              ...detail,
              discount: disc,
              amount: newAmount,
              capacity: product?.capacity,
            };
          }) || [];
        let paymentsF = [];
        if (isNationalClient) {
          paymentsF = payments.filter(
            (py) => py.label?.toLowerCase() === "nota nacional"
          );
        } else {
          paymentsF =
            isDiscount > 0
              ? payments.filter(
                (py) =>
                  !py.label.includes("CONDON") &&
                  py.label?.toLowerCase() !== "nota nacional"
              )
              : payments.filter(
                (py) => py.label?.toLowerCase() !== "nota nacional"
              );
        }

        const filteredPaymentsEdit = filterByRoutePayments(paymentsF);
        handleNewValues({
          unitPriceKg: detailsResponse.unitPriceKg,
          unitPriceLt: detailsResponse.unitPriceLt,
          noteDetails: updatingDiscount,
          discount: isCreditNote
            ? 0
            : updatingDiscount.reduce((acc, curr) => acc + curr?.discount, 0),
          paymentsOpt: filteredPaymentsEdit,
          idPayment: isNationalClient
            ? filteredPaymentsEdit.find((py) =>
              py.label?.toLowerCase().includes("nota nacional")
            ) || null
            : null,
        });
      }
    }
    // eslint-disable-next-line
  }, [successDetails, idAccount, errorDetails]);

  useEffect(() => {
    const priceU = unitType === "PORTATIL" ? unitPriceKg : unitPriceLt;
    const qtTotal = product?.capacity * quantity * priceU || 0;
    const isCreditSuspended = detailsResponse?.isCreditSuspended === 1;
    handleNewValues({
      amountDetail: parseFloat(qtTotal)?.toFixed(2),
    });
    if (isCreditSuspended) {
      handleNewValues({
        paymentsOpt: filterByRoutePayments(paymentsOpt.filter(
          (py) =>
            py.label !== "CREDITO" &&
            !py.label.includes("CONDON") &&
            py.label?.toLowerCase() !== "nota nacional"
        )),
      });
    }
    // eslint-disable-next-line
  }, [quantity, product, unitPriceKg, unitPriceLt]);

  useEffect(() => {
    products?.length === 1 && handleNewValues({ product: products[0] });
    // eslint-disable-next-line
  }, [products]);

  useEffect(() => {
    let totalAmount = 0;
    if (noteDetails.length > 0) {
      totalAmount = noteDetails.reduce((acc, curr) => {
        return acc + cleanNumber(curr.amount);
      }, 0);
    }
    handleNewValues({
      amount: parseFloat(totalAmount.toFixed(2)),
    });
    // eslint-disable-next-line
  }, [noteDetails]);

  useEffect(() => {
    if (!idAccount || !idPayment || noteDetails.length === 0 || !folio) {
      setBlockBtn(true);
    } else {
      setBlockBtn(false);
    }
    // eslint-disable-next-line
  }, [idAccount, folio, idPayment, noteDetails]);

  useEffect(() => {
    isEdit && fetchCustomerDetails(effectiveDate, idAccount?.idAccount);
  }, [isEdit]);

  // Re-fetch when custom date changes with debounce (1s)
  useEffect(() => {
    const accountId = idAccount?.value ?? idAccount?.idAccount;
    if (!canChangeDate || !accountId) return;
    const timer = setTimeout(() => {
      fetchCustomerDetails(customDate, accountId);
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [customDate, idAccount]);
  
  return (
    <Grid container spacing={2}>
      {canChangeDate && (isNewNote || (note?.id?.length < 36)) && (
        <Grid item xs={12}>
          <TextField
            label="Fecha de precio"
            type="date"
            value={customDate}
            onChange={(e) => setCustomDate(e.target.value)}
            variant="outlined"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: newDate(),
              min: newDate({diffDays: -31})
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={8}>
        <form onSubmit={(e) => handleSearchCustomers(e)}>
          <Autocomplete
            id="liquidation-customers-options"
            options={customersOpt?.filter((acc) =>
              acc.accountType.includes(settlement?.unit?.type)
            )}
            value={idAccount}
            inputValue={searchCustomer}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => (
              <>
                <TextField
                  {...params}
                  label={
                    loadingCustomers || loadingPublic
                      ? "Cargando..."
                      : success || successPublic
                        ? `Cuentas`
                        : "Buscar Cuenta"
                  }
                  variant="outlined"
                  placeholder="Ingrese Nombre "
                  name="searchCustomer"
                  onChange={handleInputOnChange}
                  error={fieldErrors?.idAccount}
                  helperText={
                    fieldErrors?.idAccount ||
                    (detailsResponse?.isCreditSuspended === 1 && (
                      <Typography
                        variant="caption"
                        style={{
                          color: orange[500],
                        }}
                      >
                        El Credito de esta cuenta se encuentra Suspendido
                      </Typography>
                    )) ||
                    ""
                  }
                />
                <Box
                  style={{
                    position: "absolute",
                    right: 30,
                    top: 8,
                    display: "flex",
                  }}
                >
                  <RegularButton
                    justIcon
                    round
                    color="transparent"
                    onClick={(e) => handleSearchCustomers(e)}
                    size="sm"
                    loading={loadingCustomers || loadingPublic}
                  >
                    <SearchIcon style={{ color: blue[800] }} />
                  </RegularButton>
                  <RegularButton
                    justIcon
                    round
                    color="transparent"
                    onClick={() =>
                      handleNewValues({ searchCustomer: "", idAccount: null })
                    }
                    size="sm"
                    tooltip="Limpiar"
                    disabled={loadingCustomers || loadingPublic}
                  >
                    <CloseIcon />
                  </RegularButton>
                </Box>
              </>
            )}
            disabled={loadingCustomers}
            fullWidth
            onChange={(e, v) => handleAccount(v)}
            noOptionsText="No se encuentra el Cliente"
            style={{
              position: "relative",
            }}
            disableClearable={true}
          />
        </form>
      </Grid>
      <Grid item xs={12} sm={4}>
        <RegularButton
          fullWidth
          color="info"
          onClick={(e) => handleSearchPublic(e)}
          loading={loadingCustomers || loadingPublic}
          disabled={loadingCustomers || loadingPublic}
        >
          Buscar publico general
        </RegularButton>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Folio"
          name="folio"
          value={folio}
          variant="outlined"
          fullWidth
          error={fieldErrors?.folio}
          helperText={fieldErrors?.folio || ""}
          disabled
          inputProps={{ maxLength: 10 }}
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          id="payments-liquidations-id"
          options={paymentsOpt}
          value={idPayment}
          getOptionLabel={(option) => option.label || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Tipo de Pago"
              variant="outlined"
              fullWidth
              error={fieldErrors?.idPayment}
              helperText={fieldErrors?.idPayment || ""}
            />
          )}
          onChange={(e, v) => handlePayment(v)}
          disabled={loadingPublic || loadingCustomers || loadingDetails}
          size="small"
        />
      </Grid>
      {loadingDetails && (
        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography variant="subtitle1">
          Detalles {isEdit ? "- Edición" : ""}
        </Typography>
      </Grid>
      <Grid item xs={12} style={isEdit ? style : null}>
        <Autocomplete
          id="liquidation-products-options"
          options={products}
          value={product}
          getOptionLabel={(option) => option.label || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Producto"
              variant="outlined"
              fullWidth
            />
          )}
          onChange={(e, v) => handleProduct(v)}
          disabled={!isManual && !isNewNote}
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={4} style={isEdit ? style : null}>
        <TextField
          label="Cantidad"
          name="quantity"
          type="number"
          value={quantity}
          onChange={handleQuantity}
          variant="outlined"
          fullWidth
          inputProps={{ min: 1, step: unitType === "PORTATIL" ? 1 : 0.1 }}
          onFocus={() =>
            resetOnClick(handleInputOnChange, quantity, "quantity")
          }
          disabled={!isManual && !isNewNote}
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={4} style={isEdit ? style : null}>
        <TextField
          label="Precio"
          value={unitType === "PORTATIL" ? unitPriceKg : unitPriceLt}
          variant="outlined"
          fullWidth
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            inputProps: { min: 0, right: "1" },
          }}
          disabled
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={4} style={isEdit ? style : null}>
        <TextField
          label="Total"
          name="amountDetail"
          value={amountDetail}
          variant="outlined"
          fullWidth
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            inputProps: { min: 0, right: "1" },
          }}
          disabled
          size="small"
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 16,
        }}
      >
        {isEdit && (
          <RegularButton
            color="transparent"
            onClick={() =>
              handleNewValues({
                isEdit: false,
                amountDetail: 0,
                quantity: 1,
              })
            }
          >
            Cancelar Edición
          </RegularButton>
        )}
        <RegularButton
          color="info"
          onClick={handleAddNoteDetail}
          disabled={
            quantity === 0 ||
            unitPriceKg === 0 ||
            unitPriceLt === 0 ||
            !product?.id
          }
        >
          {isEdit ? "Actualizar Detalle de Nota" : "Agregar Detalle de Nota"}
        </RegularButton>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <CardTable
          title="Detalles de Nota"
          icon={<Article />}
          blockBtn
          hasHeader
          hasControl
          columns={cols}
          data={noteDetails || []}
          pageSize={noteDetails?.length + 1}
          showPaginationBottom={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Descuento"
          name="discount"
          value={getDecimalFormat(discount) || 0}
          onChange={handleInputOnChange}
          variant="outlined"
          fullWidth
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            inputProps: { min: 0, right: "1" },
          }}
          disabled
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="IVA"
          name="tax"
          value={tax}
          variant="outlined"
          fullWidth
          inputProps={{ min: 0, right: 1 }}
          disabled
          size="small"
        />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
      }}>
        <Typography variant="h5">
          <strong>Total: $</strong> <span>$ {getDecimalFormat(amount)}</span>
        </Typography>
      </Grid>
      {detailsResponse?.isSuspended === 1 && (
        <Grid item xs={12}>
          <Typography
            variant="body1"
            align="center"
            style={{
              color: orange[500],
              fontWeight: 600,
            }}
          >
            Esta cuenta tiene su Credito Suspendido
          </Typography>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 16,
        }}
      >
        <RegularButton
          color="info"
          onClick={handleNote}
          disabled={
            loadingCustomers ||
            loadingDetails ||
            detailsResponse?.isSuspended === 1 ||
            blockBtn
          }
        >
          {editNote ? "Actualizar Nota" : "Agregar Nota"}
        </RegularButton>
      </Grid>
    </Grid>
  );
};
